import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 🔹 Local icon imports (path adjust if needed)
import trustIcon from "../assets/icons/trust.png";
import scheduleIcon from "../assets/icons/time-management.png";
import priceIcon from "../assets/icons/affordable.png";
import toolsIcon from "../assets/icons/cleaning.png";

gsap.registerPlugin(ScrollTrigger);

export default function FeaturesSection() {
  const cardsRef = useRef([]);

  const features = [
    {
      title: "Trusted Professionals",
      desc: "Experienced experts you can truly rely on.",
      img: trustIcon,
    },
    {
      title: "Flexible Scheduling",
      desc: "Services that fit your busy lifestyle.",
      img: scheduleIcon,
    },
    {
      title: "Affordable Price",
      desc: "Premium service without premium cost.",
      img: priceIcon,
    },
    {
      title: "Advanced Tools",
      desc: "Modern machines for deep, fast cleaning.",
      img: toolsIcon,
    },
  ];

  useEffect(() => {
    cardsRef.current.forEach((card) => {
      gsap.fromTo(
        card,
        {
          opacity: 0,
          y: 120,
          scale: 0.8,
          rotateX: 15,
          filter: "blur(8px)",
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          rotateX: 0,
          filter: "blur(0px)",
          ease: "power4.out",
          scrollTrigger: {
            trigger: card,
            start: "top 90%",
            end: "top 45%",
            scrub: 1.2,
          },
        }
      );
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <section className="relative w-full bg-white py-32 overflow-hidden perspective-[1200px]">
      {/* Ambient glow */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-[#e58505]/20 blur-[140px] rounded-full"></div>

      <div className="relative max-w-7xl mx-auto px-4 text-center">
        <p className="text-[14px] tracking-[0.4em] font-semibold text-[#079dcc] mb-4 uppercase">
          Why Choose Us
        </p>

        <h2 className="text-4xl md:text-5xl font-extrabold text-[#e58505] mb-24">
          Discover Useful Features
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16">
          {features.map((card, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className="
                relative bg-white rounded-3xl pt-24 pb-14 px-8
                shadow-[0_30px_80px_rgba(0,0,0,0.1)]
                transition-transform duration-500
                will-change-transform
              "
            >
              {/* Icon */}
              <div
                className="
                  absolute -top-12 left-1/2 -translate-x-1/2
                  w-24 h-24 bg-white rounded-full flex items-center justify-center
                  shadow-xl
                "
              >
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-15 h-15 object-contain"
                />
              </div>

              <h3 className="text-xl font-bold mb-4 text-[#079dcc]">
                {card.title}
              </h3>

              <p className="text-gray-500 text-sm leading-relaxed">
                {card.desc}
              </p>

              {/* Focus line */}
              <div
                className="
                  absolute bottom-0 left-1/2 -translate-x-1/2
                  w-1/3 h-[3px] bg-[#e58505] rounded-full
                "
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
